import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon, TuiLabel, TuiTextfield } from '@taiga-ui/core';
import { TuiCopy } from '@taiga-ui/kit/directives/copy';

@Component({
  selector: 'app-ios-udid-finder-result-section',
  imports: [SectionHeaderComponent, TuiTextfield, TuiLabel, TuiIcon, TuiCopy],
  templateUrl: './ios-udid-finder-result-section.component.html',
  styleUrl: './ios-udid-finder-result-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IosUdidFinderResultSectionComponent {
  readonly udid = input.required<string>();
  readonly deviceName = input<string>();
  readonly imei = input<string>();
  readonly meid = input<string>();
  readonly serial = input<string>();
  readonly version = input<string>();
  readonly product = input<string>();
}
